import { Prop, Component, Vue } from 'vue-property-decorator';
import { normalizeComponent } from 'vue-runtime-helpers';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var iniqueId = 0;
var IconMarker = /** @class */ (function (_super) {
    __extends(IconMarker, _super);
    function IconMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconMarker.prototype.onIconClick = function () {
        if (this.actionMapper) {
            this.actionMapper.onIconClick(this.iconId);
        }
    };
    __decorate([
        Prop({
            default: function () {
                return "icon-marker-" + iniqueId++;
            },
        })
    ], IconMarker.prototype, "iconId", void 0);
    __decorate([
        Prop({ default: 'marker' })
    ], IconMarker.prototype, "iconName", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], IconMarker.prototype, "width", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], IconMarker.prototype, "height", void 0);
    __decorate([
        Prop({ default: 'currentColor' })
    ], IconMarker.prototype, "iconColor", void 0);
    __decorate([
        Prop({ default: null })
    ], IconMarker.prototype, "actionMapper", void 0);
    IconMarker = __decorate([
        Component
    ], IconMarker);
    return IconMarker;
}(Vue));

/* script */
const __vue_script__ = IconMarker;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 28 50",
        "aria-labelledby": _vm.iconName,
        role: "presentation"
      },
      on: { click: _vm.onIconClick }
    },
    [
      _c("g", { attrs: { fill: _vm.iconColor } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M27.4475 18.6379C27.7072 17.2871 27.7072 15.8863 27.7072 13.8536C27.7072 6.20247 21.5048 0 13.8536 0C6.20247 0 0 6.20247 0 13.8536C0 15.903 0 17.2687 0.266239 18.5803C0.99396 22.1654 3.71079 25.3468 13.8536 40.9836C24.0268 25.7239 26.7294 22.3717 27.4475 18.6379ZM13.8536 19.6261C17.0416 19.6261 19.626 17.0418 19.626 13.8538C19.626 10.6658 17.0416 8.08146 13.8536 8.08146C10.6656 8.08146 8.08128 10.6658 8.08128 13.8538C8.08128 17.0418 10.6656 19.6261 13.8536 19.6261Z"
          }
        })
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
